<div class="row height-100">
    <div class="col-md-6" style="background-image: url(./assets/img/bg-7.jpg)">
    </div>
    <div class="col-md-6 align-self-center">
        <h4 class="card card-block loggedout-text">Logged out successfully<br/>Please close the page to clear active session</h4>
    </div>
</div>